<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>      
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <!-- <b-col cols="12" md="3">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="3">
        <InputFilter :filter="search[2]" />
      </b-col> -->

      <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import * as storeMaster from "@/store/api/master/index.js";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const options = [
      { label: "อยู่ระหว่างดำเนินการ", value: "1" },
      { label: "ส่งต่อเรื่อง", value: "2" },
      { label: "ผู้ร้องยุติเรื่อง", value: "3" },
      { label: "ยุติเรื่องในชั้นเจ้าหน้าที่", value: "4" },
      { label: "ยุติเรื่องในชั้นบังคับคดี", value: "5" },
    ];

    const officers = [{ text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" }];

    const searchList = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกเลขรับแจ้ง / เลขสารบัญ",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาดำเนินการ",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
    ];

    return {
      options,
      search: searchList,
      officers,
      officer: {
        text: "ชื่อเจ้าหน้าที่ผู้อนุมัติเอกสาร",
        value: userData.userId(),
      },
      props,
    };
  },
  mounted() {
    

    this.onSearchBtnClicked();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
    },
    onSearchBtnClicked() {
      console.log("props.mode", this.props.mode);
      
      const params = {
          code: this.search[0].value,
          startDate: this.search[1].value,
          endDate: this.search[2].value,
          userId: userData.userId(),
        };

        //console.log('onSearchBtnClicked', params)

        this.$emit("handleSubmit", params);
    },    
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
